import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteSequencerService {
 
 
  edgeRunnerApi!: string;
 
  userTractionUrl!: string;
  constructor(private http: HttpClient,public configService: ConfigurationService) { 
    this.edgeRunnerApi =this.configService.getConfig('edgeRunnerApi'),
    this.userTractionUrl = this.configService.getConfig('userTractionUrl');
  }

  get sequencersUrl(): string {
    let region = this.configService.getSelectedRegion();
    return this.configService.getConfig(region).siteSequencerUrl;
  }

  get notesUrl(): string {
    let region = this.configService.getSelectedRegion();
    return this.configService.getConfig(region).notesUrl;
  }

  get haystackUrl(): string {
    let region = this.configService.getSelectedRegion();
    return this.configService.getConfig(region).haystackUrl;
  }
  
  getSequencesBySite(siteRef: string) {
    return this.http.get(this.sequencersUrl + `/seq-mgmt/findAll?siteRef=${siteRef}`).pipe(catchError(this.handleError));
  }

  saveOrUpdateSequence(sequence: any) {
    return this.http.post(this.sequencersUrl + `/seq-mgmt/save`,sequence).pipe(catchError(this.handleError));
  }

  deleteSequence(sequenceId: any) {
    return this.http.delete(this.sequencersUrl + `/seq-mgmt/remove?seqId=${sequenceId}`).pipe(catchError(this.handleError));
  }

  runSequence(sequenceId: any) {
    return this.http.post(this.sequencersUrl + `/seq/submit?seqId=${sequenceId}`,null).pipe(catchError(this.handleError));
  }

  getWorkspaceBySite(siteRef: string, workspaceId: string | undefined) {
    return this.http.get(this.sequencersUrl + `/seq-mgmt/workspace?siteRef=${siteRef}&workspaceId=${workspaceId}`).pipe(catchError(this.handleError));
  }

  getWorkspacesListForCategory(siteRef: string, category: string) {
    return this.http.get(this.sequencersUrl + `/seq-mgmt/workspaceList?siteRef=${siteRef}&category=${category}`).pipe(catchError(this.handleError));
  }

  saveWorkspace(workspaceXml: any) {
    return this.http.put(this.sequencersUrl + `/seq-mgmt/saveworkspace`, workspaceXml).pipe(catchError(this.handleError));
  }

  deleteWorkspace(siteRef: string, workspaceId: string) {
    return this.http.delete(this.sequencersUrl + `/seq-mgmt/removeWorkspace?siteRef=${siteRef}&workspaceId=${workspaceId}`).pipe(catchError(this.handleError));
  }

  getAllSequencesPerWorkspace(siteRef: string, workspaceId: string) {
    return this.http.get(this.sequencersUrl + `/seq-mgmt/findAllPerWorkspace?siteRef=${siteRef}&workspaceId=${workspaceId}`).pipe(catchError(this.handleError));
  }

  updateAllSequences(siteRef: string, workspaceId: string, sequenceArray: any[]) {
    return this.http.put(this.sequencersUrl + `/seq-mgmt/updateMany?siteRef=${siteRef}&workspaceId=${workspaceId}`, sequenceArray).pipe(catchError(this.handleError));
  }

  getSequenceLogs(siteRef: string, sequenceId: any, sequenceRunMode: any, lokiLogs: boolean) {
    if(!lokiLogs) {
      return this.http.get(this.sequencersUrl + `/seq-logs/latest?siteRef=${siteRef}&seqId=${sequenceId}&sequenceRunMode=${sequenceRunMode}`).pipe(catchError(this.handleError));
    } else {
      return this.http.get(this.sequencersUrl + `/seq-logs/loki/latest?siteRef=${siteRef}&seqId=${sequenceId}&sequenceRunMode=${sequenceRunMode}`).pipe(catchError(this.handleError));
    }
  }

  dryRunSequence(sequenceId: string) {
    return this.http.post(this.sequencersUrl + `/seq/dryRun?seqId=${sequenceId}`, '').pipe(catchError(this.handleError));
  }

  getSequenceFunctionsList(component: string, filterApiKeys: string[] = []) {
    const endpoint = filterApiKeys.length
      ? '/seq-functions/list/filter'
      : '/seq-functions/list';
    let params = new HttpParams().set('component', component);

    filterApiKeys.forEach(filterApiKey => {
      params = params.append('appliedFilters', filterApiKey);
    });

    return this.http.get(this.configService.getConfig("1").siteSequencerUrl + endpoint, { params }).pipe(catchError(this.handleError));
  }

  saveSequenceFunction(sequenceFunction: any) {
    return this.http.post(this.configService.getConfig("1").siteSequencerUrl+ `/seq-functions/save`, sequenceFunction).pipe(catchError(this.handleError));
  }

  updateSequenceFunction(functionId: any, sequenceFunction: any) {
    return this.http.put(this.configService.getConfig("1").siteSequencerUrl+ `/seq-functions/update/${functionId}`, sequenceFunction).pipe(catchError(this.handleError));
  }

  deleteSequenceFunction(functionId: any, component: string) {
    return this.http.delete(this.configService.getConfig("1").siteSequencerUrl+ `/seq-functions/remove?functionId=${functionId}&component=${component}`).pipe(catchError(this.handleError));
  }

  updateLikeOrBookmark(request: any){
    return this.http.post(this.userTractionUrl + 'activity/likeOrBookmark', request,  { responseType: 'text'}).pipe(catchError(this.handleError));                     
  }

  getSequenceFunctionsUsage(functionId: any, component: string) {
    return this.http.get(this.configService.getConfig("1").siteSequencerUrl+ `/seq-functions/usage/${functionId}?component=${component}`).pipe(catchError(this.handleError));
  }

  getCCUAndEquipDetailsForSite(siteRef: string) {
    return this.http.get(this.notesUrl + `notes/ccu-equip-details/${siteRef}`).pipe(catchError(this.handleError));
  }

  getMicroPythonConversion(pySnippet:string,filename:string) {
    return this.http.post(this.edgeRunnerApi + `/micro-python/py-to-mpy`,{
      "snippet":pySnippet,
      "outputFileName": filename,
    },{ responseType: 'blob' }).pipe(catchError(this.handleError));
  }

  getSequenceDeliveryLogs(sequenceId: any) {
    return this.http.get(this.sequencersUrl + `/seq-msg/tracing/${sequenceId}`).pipe(catchError(this.handleError));
  }

  publishRemoteCommand(siteId: string, payload: any) {
    const command = {
      ...payload,
      siteRef: siteId
    }
 
    return this.http.post(`${this.haystackUrl}remote-command`, command, { headers: { 'content-type': 'application/json' }, observe: 'response' }).pipe(catchError(this.handleError));
  }

  /**
   * Method to fetch the models for the modal options.
  */
  getModalOptions() {
    // filter models with base protocols(protocols will be empty)
    return this.http.get(this.sequencersUrl + `/hayloft/models/external/base`).pipe(
      catchError((error) => {
        this.handleError;
        return of([]); // or return of(null) based on what fits your use case
      })
    );
  }

  /**
   * Method to fetch the points for the selected modal.
   * @param modalIds - The modal ids for which the points are to be fetched
  */
  getModelPoints(modalIds: any[]) {
    const queryString = modalIds.map(id => `model-ids=${id}`).join('&');
    return this.http.get(this.sequencersUrl + `/hayloft/models?${queryString}`).pipe(
      catchError(error => {
        console.error('Error fetching modal options:', error);
        return of([]);
      })
    );
  }

  getitemsRecommendedByAISearch(searchText: string, component: string, category: any) {
    return this.http.get(`${this.sequencersUrl}/${component}/search?component=${category}&searchText=${searchText}&limit=5`);
  }

  getRegions() {
    const url = `${this.configService.getConfig('auth').caretakerUrl}`;
    return this.http.get(`${url}/regions`).pipe(catchError(this.handleError));
  }

  getSiteRegion(siteIds: string) {
    const url = `${this.configService.getConfig('auth').caretakerUrl}/sites/regionmap`;
    return this.http.post(url, {siteIds: [siteIds]}).pipe(catchError(this.handleError));
  }

 
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error);
  }

}
